export default __webpack_public_path__ + "static/media/exterior-image.00d8310b.jpg";